import { GetListResponse, VasHistory } from "@app/types";
import HttpService from "@core/services/http/http.service";
import { Signal } from "@core/services/http/http.type";

class _VasService {
  public getVasHistories(signal?: Signal) {
    return HttpService.get<GetListResponse<VasHistory>>(
      "/user/api/v2/activities/point",
      {
        signal,
      }
    );
  }
}

const VasService = new _VasService();

export default VasService;
